(function () {
    'use strict';

    angular
        .module('app')
        .component('novedadListAdmin', {
            templateUrl: 'app/components/novedades/admin/novedad/novedad-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                        ModalService, Novedad, Language) {
        var vm = this;

        vm.lang = Language.getCurrent();

        vm.item = Novedad;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: undefined,
            idioma: vm.lang
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {'n.fecha': 'desc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Novedad) {
                            return Novedad.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'novedades.novedad.admin.delete.title',
                                body: 'novedades.novedad.admin.delete.confirm',
                                property: 'url'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();
